// ============================================================================
// LK_KATALOG - synchronisiert mit Backend LK_PREISE (server.py)
// Berlin SGB XI Leistungskomplexe 2024/2025
// ============================================================================

/**
 * Pflegegrade nach SGB XI mit monatlichen Sachleistungsbeträgen
 * Stand: 2024/2025
 */
export const PFLEGEGRADE = [
  { value: 1, label: "Pflegegrad 1", sachleistung: "131,00 €" },
  { value: 2, label: "Pflegegrad 2", sachleistung: "796,00 €" },
  { value: 3, label: "Pflegegrad 3", sachleistung: "1.497,00 €" },
  { value: 4, label: "Pflegegrad 4", sachleistung: "1.859,00 €" },
  { value: 5, label: "Pflegegrad 5", sachleistung: "2.299,00 €" }
];

/**
 * LK-Katalog - Leistungskomplexe für ambulante Pflege Berlin
 * Enthält alle LK-Codes mit Bezeichnung, Preis, AUB-Code und Kategorie
 *
 * WICHTIG: Preise müssen mit Backend LK_PREISE in server.py synchron gehalten werden!
 */
export const LK_KATALOG = {
  // Körperpflege
  LK01: { bezeichnung: "Erweiterte kleine Körperpflege", preis: 25.51, aubCode: "AUB01", aubPreis: 0.59, kategorie: "Körperpflege" },
  LK02: { bezeichnung: "Kleine Körperpflege", preis: 17.01, aubCode: "AUB02", aubPreis: 0.39, kategorie: "Körperpflege" },
  LK03a: { bezeichnung: "Erweiterte große Körperpflege ohne Baden", preis: 38.30, aubCode: "AUB03a", aubPreis: 0.88, kategorie: "Körperpflege" },
  LK03b: { bezeichnung: "Erweiterte große Körperpflege mit Baden", preis: 51.02, aubCode: "AUB03b", aubPreis: 1.17, kategorie: "Körperpflege" },
  LK04: { bezeichnung: "Große Körperpflege", preis: 34.01, aubCode: "AUB04", aubPreis: 0.78, kategorie: "Körperpflege" },
  LK05: { bezeichnung: "Lagern/Betten", preis: 8.50, aubCode: "AUB05", aubPreis: 0.20, kategorie: "Körperpflege" },
  LK06: { bezeichnung: "Hilfe bei der Nahrungsaufnahme", preis: 21.30, aubCode: "AUB06", aubPreis: 0.49, kategorie: "Körperpflege" },
  LK07a: { bezeichnung: "Darm- und Blasenentleerung", preis: 6.77, aubCode: "AUB07a", aubPreis: 0.16, kategorie: "Körperpflege" },
  LK07b: { bezeichnung: "Darm- und Blasenentleerung erweitert", preis: 17.01, aubCode: "AUB07b", aubPreis: 0.39, kategorie: "Körperpflege" },

  // Mobilität
  LK08a: { bezeichnung: "Hilfestellung beim Verlassen der Wohnung", preis: 5.94, aubCode: "AUB08a", aubPreis: 0.14, kategorie: "Mobilität" },
  LK08b: { bezeichnung: "Hilfestellung beim Wiederaufsuchen der Wohnung", preis: 5.94, aubCode: "AUB08b", aubPreis: 0.14, kategorie: "Mobilität" },
  LK09: { bezeichnung: "Begleitung außer Haus", preis: 51.02, aubCode: "AUB09", aubPreis: 1.17, kategorie: "Mobilität" },

  // Hauswirtschaft
  LK10: { bezeichnung: "Beheizen der Wohnung", preis: 4.95, aubCode: "AUB10", aubPreis: 0.11, kategorie: "Hauswirtschaft" },
  LK11a: { bezeichnung: "Reinigen der Wohnung (klein)", preis: 7.43, aubCode: "AUB11a", aubPreis: 0.17, kategorie: "Hauswirtschaft" },
  LK11b: { bezeichnung: "Reinigen der Wohnung (groß)", preis: 22.29, aubCode: "AUB11b", aubPreis: 0.51, kategorie: "Hauswirtschaft" },
  LK11c: { bezeichnung: "Reinigen der Wohnung (erweitert)", preis: 29.72, aubCode: "AUB11c", aubPreis: 0.68, kategorie: "Hauswirtschaft" },
  LK12: { bezeichnung: "Wechseln und Waschen der Kleidung", preis: 39.62, aubCode: "AUB12", aubPreis: 0.91, kategorie: "Hauswirtschaft" },
  LK13: { bezeichnung: "Einkaufen", preis: 19.81, aubCode: "AUB13", aubPreis: 0.46, kategorie: "Hauswirtschaft" },
  LK14: { bezeichnung: "Zubereitung einer warmen Mahlzeit", preis: 22.29, aubCode: "AUB14", aubPreis: 0.51, kategorie: "Hauswirtschaft" },
  LK15: { bezeichnung: "Zubereitung einer sonstigen Mahlzeit", preis: 7.43, aubCode: "AUB15", aubPreis: 0.17, kategorie: "Hauswirtschaft" },

  // Beratung
  LK16a: { bezeichnung: "Erstbesuch", preis: 42.00, aubCode: "AUB16a", aubPreis: 0.96, kategorie: "Beratung" },
  LK16b: { bezeichnung: "Folgebesuch", preis: 28.00, aubCode: "AUB16b", aubPreis: 0.64, kategorie: "Beratung" },

  // Einsatzpauschalen
  LK17a: { bezeichnung: "Einsatzpauschale Montag bis Freitag", preis: 5.37, aubCode: "AUB17a", aubPreis: 0.12, kategorie: "Pauschale" },
  LK17b: { bezeichnung: "Einsatzpauschale Wochenende/Feiertage/nachts", preis: 10.73, aubCode: "AUB17b", aubPreis: 0.25, kategorie: "Pauschale" },

  // Wohngemeinschaften
  LK19a: { bezeichnung: "Versorgung/Betreuung in Wohngemeinschaften", preis: 15.00, aubCode: "AUB19a", aubPreis: 0.34, kategorie: "Wohngemeinschaft" },
  LK19b: { bezeichnung: "Versorgung/Betreuung in WG bei Abwesenheit", preis: 7.50, aubCode: "AUB19b", aubPreis: 0.17, kategorie: "Wohngemeinschaft" },

  // Betreuung
  LK20: { bezeichnung: "Betreuungsmaßnahmen", preis: 8.26, aubCode: "AUB20", aubPreis: 0.19, kategorie: "Betreuung" },
  LK20_HH: { bezeichnung: "Häusliche Betreuung (Haushaltsbuch)", preis: 8.26, aubCode: "AUB20_HH", aubPreis: 0.19, kategorie: "Betreuung" },
};

/**
 * LK Kategorien für Gruppierung im Dropdown
 */
export const LK_KATEGORIEN = [
  "Körperpflege",
  "Mobilität",
  "Hauswirtschaft",
  "Beratung",
  "Pauschale",
  "Wohngemeinschaft",
  "Betreuung"
];

/**
 * Helper: Alle LK-Codes als Array
 */
export const LK_CODES = Object.keys(LK_KATALOG);

/**
 * Helper: LK-Katalog nach Kategorie gruppiert
 */
export const getLkByKategorie = (kategorie) => {
  return Object.entries(LK_KATALOG)
    .filter(([_, data]) => data.kategorie === kategorie)
    .reduce((acc, [code, data]) => ({ ...acc, [code]: data }), {});
};

/**
 * Helper: Preis für einen LK-Code abrufen
 */
export const getLkPreis = (lkCode) => {
  return LK_KATALOG[lkCode]?.preis || 0;
};

/**
 * Helper: Bezeichnung für einen LK-Code abrufen
 */
export const getLkBezeichnung = (lkCode) => {
  return LK_KATALOG[lkCode]?.bezeichnung || lkCode;
};
